import { AfterViewInit, Component, OnInit, OnDestroy, SimpleChanges } from '@angular/core';
import { CarritoService } from 'src/app/service/carrito/carrito.service';
import { MaestrasService } from 'src/app/service/maestras/maestras.service';
import { UsuarioService } from 'src/app/service/usuario/usuario.service';
import {MenuResponse} from 'src/app/modal/maestras/menu-response';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { NovedadesService } from 'src/app/service/catalogo/novedades.service';
// daet
import { DetalleOrdenComponent } from 'src/app/pagina-admin/dashboard/bandeja-pedido/detalle-orden/detalle-orden.component';
import {ViewChild,ElementRef} from '@angular/core';
import { MDBModalRef, MDBModalService, ModalDirective } from 'angular-bootstrap-md';
import { ModalHomeComponent } from 'src/app/modal-home/modal-home.component';
import { ToastrService } from 'ngx-toastr';
import { HeaderCommunicationService } from 'src/app/service/header/header-communication.service';
import { Subscription } from 'rxjs';
import { RateLimitService } from 'src/app/shared/services/rate-limit.service';
import { GeolocationService, GeoLocationResponse } from 'src/app/service/geolocation/geolocation.service';
import { CurrencyService } from 'src/app/service/currency/currency.service';

// nlpr ini
import { ChangeDetectionStrategy} from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDateRangePicker } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { FormControl, FormGroup } from '@angular/forms';
// nlpr fin

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  // nlpr ini
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [DatePipe],
  // nlpr fin
})
//daet ini
export class HeaderComponent implements OnInit , AfterViewInit, OnDestroy{
//export class HeaderComponent implements OnInit{
//daet fin

  @ViewChild('myModal', {static : true}) myModal:ElementRef;

  @ViewChild(ModalDirective) modallogin: ModalDirective;

  // Referencias a los dropdowns (web)
  @ViewChild('carritoDropdown', { static: false }) carritoDropdown: any;
  @ViewChild('loginDropdown', { static: false }) loginDropdown: any;

  // Referencias a los dropdowns (móvil)
  @ViewChild('carritoDropdownM', { static: false }) carritoDropdownM: any;
  @ViewChild('loginDropdownM', { static: false }) loginDropdownM: any;

  // daet ini
  modalRefCambioEstado: MDBModalRef;
  // daet fin

  // nlpr ini
  @ViewChild(MatDateRangePicker) picker!: MatDateRangePicker<any>;
  isCollapsed = true; // El menú comienza colapsado
  selectedIdCategoria: string = '';
  selectedIdSubCategoria: string = '';
  isMenuCollapsed = true;
  isCulturalMenuOpen = false;
  isPortadasMenuOpen = false;
  //startDateValue: Date | null = null;
  //endDateValue: Date | null = null;
  //startDate: Date | null = null;
  //endDate: Date | null = null;
  //selectedDateRange: { startDate: Date, endDate: Date } = { startDate: null, endDate: null };  
  //selectedDate: any = { start: null, end: null };
  minDate = new Date(1825, 0, 1);  // Año 1825 (inicio del archivo histórico)
  maxDate = new Date(new Date().getFullYear(), 11, 31); // Año actual
  maxDateString = `${new Date().getFullYear()}-12-31`; // String formato yyyy-MM-dd para inputs HTML
  //readonly startDate = new Date(1970, 0, 1);

  // Filtro para validar fechas ingresadas manualmente
  dateFilter = (date: Date | null): boolean => {
    if (!date) return false;
    const year = date.getFullYear();
    const currentYear = new Date().getFullYear();
    // Solo permitir años entre 1825 y año actual
    return year >= 1825 && year <= currentYear;
  }
  // nlpr fin

  // daet ini
  @ViewChild('txtFechaIni') refFecIni:ElementRef;
  @ViewChild('txtFechaFin') refFecFin:ElementRef;
  txtFechaIni:string="";
  txtFechaFin:string="";
  fechaIniLoad:string="";
  fechaFinLoad:string="";
  isFechaEnable:boolean;
  // daet fin
  flagActualizar=1;
  cantidadCarrito:number=0;
  cantidadCarritoAnterior:number = 0;
  menuFlag=false;
  menuResponse:MenuResponse;
  CatalogoDigital:boolean=true;
  txtBusqueda=this.utilitarioService.busqueda;
  private headerSubscription: Subscription;
  private usuarioActualizadoSubscription: Subscription;
  private rateLimitSubscription: Subscription;
  private loginStatusSubscription: Subscription;
  inicialUsuario: string = '';
  rateLimitActive = false;

  // Geolocalización
  countryCode: string = 'PE';
  countryName: string = 'Peru';
  flagUrl: string = '/assets/image/flags/pe.svg';
  geoLocationLoaded: boolean = false;

  // Bandera del usuario logueado (basada en documento)
  userCountryCode: string = 'PE';
  userCountryName: string = 'Peru';
  userFlagUrl: string = '/assets/image/flags/pe.svg';
  isPeruvianUser: boolean = true; // Por defecto asumimos peruano

  constructor(private router: Router,private carritoService:CarritoService,
    private usuarioService:UsuarioService,private maestraService:MaestrasService,private novedadesService:NovedadesService,
    // daet ini
    private modalService: MDBModalService,
    // daet fin
    public utilitarioService:UtilitarioService,
    private toastr:ToastrService,
    // nlpr ini
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private headerCommunicationService: HeaderCommunicationService,
    private rateLimitService: RateLimitService,
    private geolocationService: GeolocationService,
    private currencyService: CurrencyService,
    // nlpr fin
    ) {
      // nlpr ini
      // console.log("checkidCategoria"+this.utilitarioService.idCategoria);
      this.selectedIdCategoria=this.utilitarioService.idCategoria;
      this.selectedIdSubCategoria=this.utilitarioService.idSubCategoria;
      // nlpr fin
  }
  
  // nlpr ini
  // Función para manejar la navegación
  navigate(page: string) {
    // console.log(`Navegando a: ${page}`);
    // Aquí puedes agregar lógica para navegar a diferentes rutas
  }
  
  // Función para alternar el menú general (inicio, fotografías, etc.)
  toggleMenu() {
    // console.log('Toggling menu', this.isMenuCollapsed);
    this.isMenuCollapsed = !this.isMenuCollapsed;
    // console.log('Menu isMenuCollapsed:', this.isMenuCollapsed);
  }

  // Función para alternar el submenú de "Cultural"
  toggleCulturalMenu() {
    // console.log('Toggling submenu cultural', this.isCulturalMenuOpen);
    this.isCulturalMenuOpen = !this.isCulturalMenuOpen;
  }
  
  togglePortadaMenu() {
    // console.log('Toggling submenu portada', this.isPortadasMenuOpen);
    this.isPortadasMenuOpen = !this.isPortadasMenuOpen;
  }
  // nlpr fin

  obtenerSesion(){
    return this.usuarioService.existeSesionUsuario();
  }

  obtenerInicialUsuario(): string {
    if (!this.usuarioService.existeSesionUsuario()) {
      return '';
    }
    const nombreCompleto = this.usuarioService.obtenerNombreCompletoSesionUsuario();
    if (nombreCompleto && nombreCompleto.trim()) {
      return nombreCompleto.trim().charAt(0).toUpperCase();
    }
    return 'U'; // Default si no hay nombre
  }

  actualizarInicialUsuario(): void {
    this.inicialUsuario = this.obtenerInicialUsuario();
  }

  obtenerCantidadCarrito(){
    // Primero actualizar la cantidad desde el servicio
    this.carritoService.obtenerCantidadCarrito();
    const cantidadActual = Number(this.carritoService.cantidadCarrito);

    // Si la cantidad cambió, actualizar el flag para recargar el carrito
    if (cantidadActual !== this.cantidadCarritoAnterior) {
      // console.log('🔄 Header: Cantidad carrito cambió de', this.cantidadCarritoAnterior, 'a', cantidadActual);
      this.cantidadCarritoAnterior = cantidadActual;
      this.cantidadCarrito = cantidadActual;
      this.actualizarCarrito();
      // console.log('🔄 Header: flagActualizar incrementado a', this.flagActualizar);
    } else {
      this.cantidadCarrito = cantidadActual;
    }
  }
 
  actualizarCarrito(){
    this.flagActualizar = this.flagActualizar + 1;
    
  }

  // Mapeo de IDs a slugs amigables
  private readonly SUBCAT_SLUGS: Record<string, Record<string, string>> = {
    '1': { // FOTOGRAFÍAS
      '1': 'cultura',
      '2': 'politica',
      '3': 'deportes',
      '4': 'espectaculos',
      '11': 'regiones',
      '12': 'economia',
      '13': 'sociedad',
      '14': 'presidentes',
    },
    '2': { // PORTADAS
      '5': 'siglo-xix',
      '6': 'siglo-xx',
      '7': 'siglo-xxi',
    },
    '3': {} // CONSULTAS/HEMEROTECA
  };

  // Mapeo inverso: slug a ID
  private readonly SLUG_TO_SUBCAT_ID: Record<string, string> = {
    'cultura': '1',
    'politica': '2',
    'deportes': '3',
    'espectaculos': '4',
    'regiones': '11',
    'economia': '12',
    'sociedad': '13',
    'presidentes': '14',
    'siglo-xix': '5',
    'siglo-xx': '6',
    'siglo-xxi': '7',
  };

  buscarConsulta(idCategoria,idSubCategoria){
    const timestamp = new Date().toLocaleTimeString('es-PE', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });
    // console.log(`👆 [HEADER CLIC] [${timestamp}] buscarConsulta - idCategoria: ${idCategoria}, idSubCategoria: ${idSubCategoria}`);

    this.novedadesService.idCategoria=idCategoria;
    this.novedadesService.idSubCategoria=idSubCategoria;
    this.txtBusqueda="";
    // daet ini
    if (idCategoria==1 || idCategoria==2 || idCategoria==3){
      this.isFechaEnable=false;
    }else{
      this.isFechaEnable=true;
    }
    this.txtFechaIni="";
    this.txtFechaFin="";
    this.utilitarioService.fecIni="";
    this.utilitarioService.fecFin="";
    this.utilitarioService.idCategoria=idCategoria;
    this.utilitarioService.idSubCategoria=idSubCategoria;

    // ✅ LIMPIAR parámetros de búsqueda cuando se navega desde el header
    // Esto asegura que al hacer clic en "Fotografías" o "Portadas", se muestren los activos normales
    // y no continúe con búsquedas generales o por tags
    this.utilitarioService.busqueda = "";
    this.utilitarioService.tipobusqueda = "";
    // console.log(`🧹 [HEADER CLIC] [${timestamp}] Limpiando búsqueda y tipobusqueda para navegación limpia`);
    // daet fin
    // nlpr ini
    this.selectedIdSubCategoria=idSubCategoria;

    // Construir URL con slugs amigables
    let url = '';
    if (idCategoria==='1'){
      url = '/fotografias';
    }else if (idCategoria==='2'){
      url = '/portadas';
    }else{
      url = '/consultas';
    }

    // Agregar slug de subcategoría si existe
    if (idSubCategoria && this.SUBCAT_SLUGS[idCategoria]?.[idSubCategoria]) {
      url += '/' + this.SUBCAT_SLUGS[idCategoria][idSubCategoria];
    }

    // console.log(`👆 [HEADER CLIC] [${timestamp}] Navegando a: ${url}`);
    this.router.navigateByUrl(url);
    this.closeMenu();
    // nlpr fin
  }

  generaNss() {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < charactersLength; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  obtenerMenu(){
    this.menuResponse= new MenuResponse();
    this.maestraService.obtenerMenu().subscribe(
      data => {
        this.menuResponse = data;
        this.menuFlag = true;
      },
      error => {
        console.error('Error al obtener menú:', error);

        // Manejar específicamente el error 429 (Too Many Requests)
        if (error.status === 429) {
          // Extraer información detallada del error
          const errorBody = error.error;
          const retrySeconds = errorBody?.retryAfterSeconds || 8;
          const esHome = this.router.url === '/' || this.router.url === '/inicio';

          // console.log('⏱️ Rate limit detectado en header:', {
            // retryAfterSeconds: retrySeconds,
            // ip: errorBody?.ip,
            // path: errorBody?.path,
            // penaltyLevel: errorBody?.penaltyLevel,
            // esHome: esHome
          // });

          this.utilitarioService.loading = false;
          // Activar el rate limiting usando el servicio centralizado
          this.rateLimitService.activateRateLimit(retrySeconds, esHome);
        } else {
          // Manejar otros errores HTTP
          this.toastr.error(
            'No se pudo cargar el menú. Por favor, intenta nuevamente.',
            'Error de conexión',
            {
              timeOut: 3000,
              progressBar: true,
              closeButton: true
            }
          );
        }
      }
    );
  }

  buscar(){
    // console.log(this.txtBusqueda);

    // Limpiar espacios y convertir a minúsculas
    const cleanSearch = this.txtBusqueda ? this.txtBusqueda.trim().toLowerCase() : '';

    // Validar que haya al menos texto O fechas
    if (!cleanSearch && !this.txtFechaIni && !this.txtFechaFin) {
      return;
    }

    this.utilitarioService.busqueda = cleanSearch;
    this.utilitarioService.fecIni = this.txtFechaIni;
    this.utilitarioService.fecFin = this.txtFechaFin;

    // Las búsquedas se realizan en /consultas
    const baseRoute = '/consultas';

    // Construir queryParams según los filtros aplicados
    let queryParams: any = {};

    // Agregar texto de búsqueda si existe
    if (cleanSearch) {
      queryParams.q = cleanSearch;
    }

    // Agregar fechas si existen
    if (this.txtFechaIni && this.txtFechaFin) {
      queryParams.fi = this.txtFechaIni;
      queryParams.ff = this.txtFechaFin;
    }

    // Agregar categoría si está seleccionada
    if (this.utilitarioService.idCategoria === '1' || this.selectedIdCategoria === '1') {
      queryParams.cat = 'fotografias';
    } else if (this.utilitarioService.idCategoria === '2' || this.selectedIdCategoria === '2') {
      queryParams.cat = 'portadas_historicas';
    }
    // Si no hay categoría seleccionada, no se envía el parámetro y busca en todas

    // Siempre agregar página
    queryParams.page = 1;

    // Navegar con query params para realizar la búsqueda
    this.router.navigate([baseRoute], {
      queryParams: queryParams
    });
  }

  // daet1
  visibilidad(selector) {
      // console.log("visibilidad"+selector);
      /*
      switch(selector){
        case "#subMenuFotografia":{
          this.utilitarioService.seccion="F";
          var ele1:any = document.querySelector("#subMenuFotografia"); 
          ele1.style.display = "block";
          var ele2:any = document.querySelector("#subMenuPortada"); 
          ele2.style.display = "none";
          var ele3:any = document.querySelector("#subMenuHemeroteca");
          ele3.style.display = "none";
          // console.log("Fotografia aplicado");
          break;
        }
        case "#subMenuPortada":{
          this.utilitarioService.seccion="P";
          var ele1:any = document.querySelector("#subMenuFotografia"); 
          ele1.style.display = "none";
          var ele2:any = document.querySelector("#subMenuPortada"); 
          ele2.style.display = "block";
          var ele3:any = document.querySelector("#subMenuHemeroteca");
          ele3.style.display = "none";
          // console.log("Portada aplicado");
          break;
        }
        case "#subMenuHemeroteca":{
          this.utilitarioService.seccion="H";
          var ele1:any = document.querySelector("#subMenuFotografia"); 
          ele1.style.display = "none";
          var ele2:any = document.querySelector("#subMenuPortada"); 
          ele2.style.display = "none";
          var ele3:any = document.querySelector("#subMenuHemeroteca");
          ele3.style.display = "block";
          // console.log("Hemeroteca aplicado");
          break;
        }
      }*/
      /*
      var elemento = document.querySelector(selector);         
      if (elemento != null) {
        let display = elemento.style.display;
        if(display=="none"||display===""){
        elemento.style.display = "block";
        }
        if(display==="block"){
          elemento.style.display = "none";
        }
      }*/
  }
  
  ngOnInit(): void {
    // console.log("ngOnInit"+this.utilitarioService.idCategoria);
    this.obtenerMenu();
    this.carritoService.obtenerCantidadCarrito();

    // Cargar geolocalización del visitante
    this.loadGeoLocation();

    // Suscribirse al estado del rate limit
    this.rateLimitSubscription = this.rateLimitService.rateLimitState$.subscribe(
      state => {
        this.rateLimitActive = state.isActive && state.timeRemaining > 0;
        // console.log('🚫 [HEADER] Rate limit estado:', this.rateLimitActive);
      }
    );

    // Inicializar la inicial del usuario
    this.actualizarInicialUsuario();

    // Si el usuario ya está logueado, cargar su nacionalidad
    if (this.usuarioService.existeSesionUsuario()) {
      this.loadUserNationality();
    }

    // Suscribirse a cambios en los datos del usuario
    this.usuarioActualizadoSubscription = this.usuarioService.onDatosUsuarioActualizados.subscribe(() => {
      this.actualizarInicialUsuario();
      // Recargar nacionalidad cuando se actualizan los datos
      this.loadUserNationality();
    });

    // Suscribirse a cambios de login/logout
    this.loginStatusSubscription = this.usuarioService.onLoginStatusChange.subscribe((isLoggedIn) => {
      // console.log('🔐 [HEADER] Estado de login cambió:', isLoggedIn);
      this.actualizarInicialUsuario();
      if (isLoggedIn) {
        // Usuario se logueó - cargar su nacionalidad
        this.loadUserNationality();
      } else {
        // Usuario cerró sesión - resetear a valores de geolocalización
        this.isPeruvianUser = true;
        this.userCountryCode = this.countryCode;
        this.userCountryName = this.countryName;
        this.userFlagUrl = this.flagUrl;
        // Actualizar moneda basándose en geolocalización
        this.currencyService.refreshCurrency();
      }
    });

    // Suscribirse a solicitudes de apertura del modal de login
    this.headerCommunicationService.openLoginModal$.subscribe(() => {
      this.abrirModalLogin();
    });

    // Inicializar cantidad anterior
    this.cantidadCarritoAnterior = Number(this.carritoService.cantidadCarrito);

    // Suscribirse a cambios en el carrito
    this.carritoService.carritoActualizado$.subscribe(cantidad => {
      //console.log('🔔 Header: Notificación de cambio en carrito. Nueva cantidad:', cantidad);
      if (cantidad !== this.cantidadCarritoAnterior) {
        //console.log('🔄 Header: Cantidad carrito cambió de', this.cantidadCarritoAnterior, 'a', cantidad);
        this.cantidadCarritoAnterior = cantidad;
        this.cantidadCarrito = cantidad;
        this.actualizarCarrito();
        //console.log('🔄 Header: flagActualizar incrementado a', this.flagActualizar);
      }
    });

    // Suscribirse a cambios en query params para detectar la categoría en /consultas
    this.route.queryParams.subscribe(params => {
      const cat = params['cat'];
      if (cat) {
        // console.log('🔍 [HEADER] Categoría detectada desde query params:', cat);

        // Mapear categoría del query param a ID de categoría
        if (cat.toLowerCase() === 'fotografias') {
          this.selectedIdCategoria = '1';
          this.utilitarioService.idCategoria = '1';
          this.isCulturalMenuOpen = true;
          this.isPortadasMenuOpen = false;
          // console.log('✅ [HEADER] Categoría actualizada a: Fotografías (ID: 1)');
        } else if (cat.toLowerCase() === 'portadas_historicas') {
          this.selectedIdCategoria = '2';
          this.utilitarioService.idCategoria = '2';
          this.isCulturalMenuOpen = false;
          this.isPortadasMenuOpen = true;
          // console.log('✅ [HEADER] Categoría actualizada a: Portadas Históricas (ID: 2)');
        }
      }
    });

    // 🔔 Suscribirse a notificaciones desde componentes de detalle
    this.headerSubscription = this.headerCommunicationService.headerUpdate$.subscribe(data => {
      //console.log('🔔 [HEADER] Recibida notificación de detalle:', data);

      if (data.categoryId) {
        this.selectedIdCategoria = data.categoryId;
        this.utilitarioService.idCategoria = data.categoryId;

        // Abrir el menú correspondiente
        if (data.categoryId === '1') {
          this.isCulturalMenuOpen = true;
          this.isPortadasMenuOpen = false;
        } else if (data.categoryId === '2') {
          this.isCulturalMenuOpen = false;
          this.isPortadasMenuOpen = true;
        }
      }

      if (data.subCategoryId) {
        this.selectedIdSubCategoria = data.subCategoryId;
        this.utilitarioService.idSubCategoria = data.subCategoryId;
      }

      //console.log('✅ [HEADER] Categoría y subcategoría actualizadas:', {selectedIdCategoria: this.selectedIdCategoria,selectedIdSubCategoria: this.selectedIdSubCategoria});
    });

    // nlpr ini
    switch (this.utilitarioService.idCategoria) {
      case "1":
        // console.log("Categoría 1 seleccionada");
        this.visibilidad("#subMenuFotografia");
        break;

      case "2":
        // console.log("Categoría 2 seleccionada");
        this.visibilidad("#subMenuPortada");
        break;

      case "3":
        // console.log("Categoría 3 seleccionada");
        this.visibilidad("#subMenuHemeroteca");
        break;

      default:
        // console.log("Categoría no seleccionada o valor no válido");
        this.visibilidad("#subMenuFotografia");
        break;
    }
    // nlpr fin

    // Verificar cambios en utilitarioService para actualizar selección desde componentes hijos
    setInterval(() => {
      this.obtenerCantidadCarrito();

      // Sincronizar categoría y subcategoría desde utilitarioService
      if (this.utilitarioService.idCategoria !== this.selectedIdCategoria) {
        const timestamp = new Date().toLocaleTimeString('es-PE', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });
        //console.log(`🔄 [HEADER] [${timestamp}] Detectado cambio de categoría:`, this.utilitarioService.idCategoria, '| Anterior:', this.selectedIdCategoria);
        this.selectedIdCategoria = this.utilitarioService.idCategoria;
      }
      if (this.utilitarioService.idSubCategoria !== this.selectedIdSubCategoria) {
        const timestamp = new Date().toLocaleTimeString('es-PE', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });
        //console.log(`🔄 [HEADER] [${timestamp}] Detectado cambio de subcategoría:`, this.utilitarioService.idSubCategoria, '| Anterior:', this.selectedIdSubCategoria);
        this.selectedIdSubCategoria = this.utilitarioService.idSubCategoria;
      }
    }, 100);
  }

  // daet ini
  //ngAfterViewInit () {
    //this.onOpenOrdenDetalle();
  //} 
  // daet fin

  ngAfterViewInit(): void {
    // Esto se ejecutará después de que la vista se haya inicializado completamente
    // nlpr ini
    // console.log("ngAfterViewInit:"+this.utilitarioService.idCategoria);
    // console.log("subMenuFotografia");
    // nlpr fin
    /*
    switch (this.utilitarioService.idCategoria) {
      case "1":
        // console.log("Categoría 1 seleccionada");
        this.visibilidad("#subMenuFotografia");
        break;

      case "2":
        // console.log("Categoría 2 seleccionada");
        this.visibilidad("#subMenuPortada");
        break;

      case "3":
        // console.log("Categoría 3 seleccionada");
        this.visibilidad("#subMenuHemeroteca");
        break;

      default:
        // console.log("Categoría no seleccionada o valor no válido");
        this.visibilidad("#subMenuFotografia");
        break;
    }*/
  }

  // daet ini
onBuscar(evento: String) {
  this.utilitarioService.loading = true;

  // Si se invoca en "load" solo seteamos los textos para mostrar (no impacta la validación)
  if (evento === "load") {
    const dateCurrent = new Date();
    this.fechaIniLoad = "01/01/" + dateCurrent.getFullYear();
    this.fechaFinLoad = "31/12/" + dateCurrent.getFullYear();
    this.utilitarioService.loading = false;
    return;
  }

  // console.log("Buscar:", this.txtBusqueda, ">> txtFechaIni:", this.txtFechaIni, ">> txtFechaFin:", this.txtFechaFin);

  // Limpiar búsqueda
  const cleanSearch = this.txtBusqueda ? this.txtBusqueda.trim().toLowerCase() : '';

  this.utilitarioService.busqueda = cleanSearch;
  this.utilitarioService.fecIni = this.txtFechaIni;
  this.utilitarioService.fecFin = this.txtFechaFin;

  const baseRoute = '/consultas';
  let queryParams: any = {};

  // -- VALIDACIÓN HEMEROTECA (rango específico) --
  if (this.txtFechaIni && this.txtFechaFin && this.utilitarioService.idCategoria === '3') {
    // Rango permitido (incluye 01/01/1825 y 31/12/1951)
    const fecIniRanIni = new Date(1825, 0, 1);    // 01/01/1825 (mes 0 = enero)
    const fecIniRanFin = new Date(1951, 11, 31);  // 31/12/1951 (mes 11 = diciembre)

    // Parseo robusto (espera "yyyy-MM-dd")
    const fecIniInpIni = this.parseIsoDate(this.utilitarioService.fecIni);
    const fecIniInpFin = this.parseIsoDate(this.utilitarioService.fecFin);

    // console.log('🔎 Hemeroteca - parsed ini:', fecIniInpIni.toString(), 'parsed fin:', fecIniInpFin.toString());

    if (isNaN(fecIniInpIni.getTime()) || isNaN(fecIniInpFin.getTime())) {
      this.showWarning("Fechas inválidas para Hemeroteca");
      this.utilitarioService.loading = false;
      return;
    }

    let validaFecha = true;
    if (fecIniInpIni.getTime() < fecIniRanIni.getTime()) validaFecha = false;
    if (fecIniInpFin.getTime() > fecIniRanFin.getTime()) validaFecha = false;

    if (!validaFecha) {
      this.showWarning("Rango de fechas no permitido para Hemeroteca");
      this.utilitarioService.loading = false;
      return;
    }
  }

  // Construir queryParams: texto
  if (cleanSearch) {
    queryParams.q = cleanSearch;
  }

  // -- VALIDACIÓN GENERAL DE FECHAS (si se ingresaron ambas) --
  if (this.txtFechaIni && this.txtFechaFin) {
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

    if (!dateRegex.test(this.txtFechaIni) || !dateRegex.test(this.txtFechaFin)) {
      this.showWarning("Formato de fecha inválido. Use el selector de fechas (yyyy-MM-dd).");
      this.utilitarioService.loading = false;
      return;
    }

    // Parsear como fecha LOCAL para evitar efectos TZ
    const fechaIni = this.parseIsoDate(this.txtFechaIni);
    const fechaFin = this.parseIsoDate(this.txtFechaFin);

    // console.log('🔎 parsed fechaIni:', fechaIni.toString(), 'parsed fechaFin:', fechaFin.toString());

    if (isNaN(fechaIni.getTime()) || isNaN(fechaFin.getTime())) {
      this.showWarning("Las fechas ingresadas no son válidas.");
      this.utilitarioService.loading = false;
      return;
    }

    if (fechaIni.getTime() > fechaFin.getTime()) {
      this.showWarning("La fecha de inicio debe ser menor o igual a la fecha de fin.");
      this.utilitarioService.loading = false;
      return;
    }

    const yearIni = fechaIni.getFullYear();
    const yearFin = fechaFin.getFullYear();
    const currentYear = new Date().getFullYear();

    // Validación inclusiva: 1825 <= año <= currentYear
    if (yearIni < 1825 || yearIni > currentYear || yearFin < 1825 || yearFin > currentYear) {
      this.showWarning(`Los años deben estar entre 1825 y ${currentYear}.`);
      this.utilitarioService.loading = false;
      return;
    }

    // si todo OK, agregamos a queryParams
    queryParams.fi = this.txtFechaIni;
    queryParams.ff = this.txtFechaFin;
  }

  // Categoría (si aplica)
  if (this.utilitarioService.idCategoria === '1' || this.selectedIdCategoria === '1') {
    queryParams.cat = 'fotografias';
  } else if (this.utilitarioService.idCategoria === '2' || this.selectedIdCategoria === '2') {
    queryParams.cat = 'portadas_historicas';
  }

  // Siempre agregar página
  queryParams.page = 1;

  // Navegar con query params
  this.router.navigate([baseRoute], { queryParams });

  // limpieza final
  this.utilitarioService.loading = false;
  this.picker.close?.();
  this.range.reset?.();
}

  // daet fin

  // daet ini
  onOpenOrdenDetalle() {
    //console.log("orderAdminBean",orderAdminBean);
    this.modalRefCambioEstado = this.modalService.show(
      ModalHomeComponent,
      //DetalleOrdenComponent,
      {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: false,
        class: 'modal-dialog modal-dialog-centered modal-dialog-scrollable modal-notify modal-warning modal-lg',
        containerClass: 'top',
        animated: true,
        data: {
          idOrden: 1,          
          nroOrden:1,
          total: 1,
          date: '01/01/2021',
          clientName: 'a',
          stateName: 'a',         
        }
      }
    );
  }
  onClosemodal(){
    this.modalRefCambioEstado.hide();
  }
  // daet fin

  showWarning(mensaje) {
    this.toastr.warning(mensaje);
  }

  /**
   * Valida las fechas ingresadas manualmente en los inputs HTML tipo date
   */
validateManualDateInput(tipo: 'inicio' | 'fin'): void {
  const currentYear = new Date().getFullYear();
  const minYear = 1825;
  const maxYear = currentYear;
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

  // ✅ helper para mostrar info en consola (acepta varios parámetros)
  const dump = (label: string, ...values: any[]) => console.log(`🔸 ${label}:`, ...values);

  if (tipo === 'inicio') {
    if (!this.txtFechaIni) return;

    dump('raw txtFechaIni', this.txtFechaIni);

    if (!dateRegex.test(this.txtFechaIni)) {
      this.showWarning("Formato de fecha inválido. Use yyyy-MM-dd (ej: 2025-01-01).");
      this.txtFechaIni = '';
      return;
    }

    const yearFromString = Number(this.txtFechaIni.substring(0, 4));
    dump('yearFromString', yearFromString);

    const fechaLocal = this.parseIsoDate(this.txtFechaIni);
    dump('fechaLocal', isNaN(fechaLocal.getTime()) ? 'INVALID' : fechaLocal.toString());

    const year = Number.isFinite(yearFromString) ? yearFromString : fechaLocal.getFullYear();

    dump('year used for validation', year, 'min', minYear, 'max', maxYear);

    if (!Number.isFinite(year) || year < minYear || year > maxYear) {
      this.showWarning(`El año de inicio debe estar entre ${minYear} y ${maxYear}.`);
      this.txtFechaIni = '';
      return;
    }

    dump('✅ Fecha inicio aceptada', this.txtFechaIni);

  } else { // fin
    if (!this.txtFechaFin) return;

    dump('raw txtFechaFin', this.txtFechaFin);

    if (!dateRegex.test(this.txtFechaFin)) {
      this.showWarning("Formato de fecha inválido. Use yyyy-MM-dd (ej: 2025-01-01).");
      this.txtFechaFin = '';
      return;
    }

    const yearFromString = Number(this.txtFechaFin.substring(0, 4));
    dump('yearFromString (fin)', yearFromString);

    const fechaLocal = this.parseIsoDate(this.txtFechaFin);
    dump('fechaLocal (fin)', isNaN(fechaLocal.getTime()) ? 'INVALID' : fechaLocal.toString());

    const year = Number.isFinite(yearFromString) ? yearFromString : fechaLocal.getFullYear();

    dump('year used for validation (fin)', year, 'min', minYear, 'max', maxYear);

    if (!Number.isFinite(year) || year < minYear || year > maxYear) {
      this.showWarning(`El año de fin debe estar entre ${minYear} y ${maxYear}.`);
      this.txtFechaFin = '';
      return;
    }

    if (this.txtFechaIni) {
      const ini = this.parseIsoDate(this.txtFechaIni);
      if (!isNaN(ini.getTime()) && !isNaN(fechaLocal.getTime())) {
        if (fechaLocal.getTime() < ini.getTime()) {
          this.showWarning("La fecha de fin debe ser mayor o igual a la fecha de inicio.");
          this.txtFechaFin = '';
          return;
        }
      }
    }

    dump('✅ Fecha fin aceptada', this.txtFechaFin);
  }
}


  // daet1
  hideModal() {
    this.modallogin.hide();
  }

  /**
   * Abre el modal de login programáticamente
   * Se activa desde otros componentes a través del servicio de comunicación
   */

/**
 * Convierte una cadena ISO 'yyyy-MM-dd' a Date LOCAL (hora 00:00 local).
 * Devuelve Date inválida (NaN) si el string no es correcto.
 */
private parseIsoDate(iso: string): Date {
  if (!iso || iso.length < 10) return new Date(NaN);
  const y = Number(iso.substring(0, 4));
  const m = Number(iso.substring(5, 7)); // 01..12
  const d = Number(iso.substring(8, 10)); // 01..31
  if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) return new Date(NaN);
  return new Date(y, m - 1, d); // mes -> 0-index, crea fecha LOCAL (00:00 local)
}

/**
 * Convierte un objeto Date a cadena ISO 'yyyy-MM-dd' (formato usado por inputs HTML tipo date).
 * Devuelve cadena vacía si la fecha es inválida.
 */
private formatDateToIso(date: Date): string {
  if (!date || isNaN(date.getTime())) return '';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // +1 porque getMonth() es 0-indexed
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}


  abrirModalLogin() {
    setTimeout(() => {
      // Simular clic en el botón que abre el dropdown del login
      const loginButton = document.getElementById('modallogin1');
      if (loginButton) {
        loginButton.click();
        // console.log('✅ Modal de login abierto desde servicio de comunicación');
      }
    }, 100);
  }

  closeItem() {
    // console.log("hi1");
    // console.log("hic"+document.getElementById('modallogin').style.display);
    document.getElementById('modallogin').style.display="none";
    document.getElementById('modallogin1').click();
    // console.log("hi2");
    //ngDropdown.close();
  }

  // Cerrar dropdown del carrito (web)
  cerrarDropdownCarrito() {
    // console.log('🔴 Intentando cerrar dropdown carrito (web)');
    if (this.carritoDropdown) {
      try {
        // Probar diferentes métodos de cierre según la API de ngDropdown
        if (typeof this.carritoDropdown.hide === 'function') {
          this.carritoDropdown.hide();
          // console.log('✅ Dropdown cerrado con hide()');
        } else if (typeof this.carritoDropdown.close === 'function') {
          this.carritoDropdown.close();
          // console.log('✅ Dropdown cerrado con close()');
        } else if (typeof this.carritoDropdown.toggle === 'function') {
          this.carritoDropdown.toggle();
          // console.log('✅ Dropdown cerrado con toggle()');
        } else {
          console.warn('⚠️ No se encontró método para cerrar dropdown');
          // console.log('Métodos disponibles:', Object.getOwnPropertyNames(Object.getPrototypeOf(this.carritoDropdown)));
        }
      } catch (error) {
        console.error('❌ Error al cerrar dropdown:', error);
      }
    } else {
      console.warn('⚠️ carritoDropdown no está definido');
    }
  }

  // Cerrar dropdown de login (web)
  cerrarDropdownLogin() {
    // console.log('🔴 Intentando cerrar dropdown login (web)');
    if (this.loginDropdown) {
      try {
        if (typeof this.loginDropdown.hide === 'function') {
          this.loginDropdown.hide();
          // console.log('✅ Dropdown cerrado con hide()');
        } else if (typeof this.loginDropdown.close === 'function') {
          this.loginDropdown.close();
          // console.log('✅ Dropdown cerrado con close()');
        } else if (typeof this.loginDropdown.toggle === 'function') {
          this.loginDropdown.toggle();
          // console.log('✅ Dropdown cerrado con toggle()');
        } else {
          console.warn('⚠️ No se encontró método para cerrar dropdown');
          // console.log('Métodos disponibles:', Object.getOwnPropertyNames(Object.getPrototypeOf(this.loginDropdown)));
        }
      } catch (error) {
        console.error('❌ Error al cerrar dropdown:', error);
      }
    } else {
      console.warn('⚠️ loginDropdown no está definido');
    }
  }

  // Cerrar dropdown del carrito (móvil)
  cerrarDropdownCarritoM() {
    // console.log('🔴 Intentando cerrar dropdown carrito (móvil)');
    if (this.carritoDropdownM) {
      try {
        if (typeof this.carritoDropdownM.hide === 'function') {
          this.carritoDropdownM.hide();
          // console.log('✅ Dropdown cerrado con hide()');
        } else if (typeof this.carritoDropdownM.close === 'function') {
          this.carritoDropdownM.close();
          // console.log('✅ Dropdown cerrado con close()');
        } else if (typeof this.carritoDropdownM.toggle === 'function') {
          this.carritoDropdownM.toggle();
          // console.log('✅ Dropdown cerrado con toggle()');
        } else {
          console.warn('⚠️ No se encontró método para cerrar dropdown');
        }
      } catch (error) {
        console.error('❌ Error al cerrar dropdown:', error);
      }
    }
  }

  // Cerrar dropdown de login (móvil)
  cerrarDropdownLoginM() {
    // console.log('🔴 Intentando cerrar dropdown login (móvil)');
    if (this.loginDropdownM) {
      try {
        if (typeof this.loginDropdownM.hide === 'function') {
          this.loginDropdownM.hide();
          // console.log('✅ Dropdown cerrado con hide()');
        } else if (typeof this.loginDropdownM.close === 'function') {
          this.loginDropdownM.close();
          // console.log('✅ Dropdown cerrado con close()');
        } else if (typeof this.loginDropdownM.toggle === 'function') {
          this.loginDropdownM.toggle();
          // console.log('✅ Dropdown cerrado con toggle()');
        } else {
          console.warn('⚠️ No se encontró método para cerrar dropdown');
        }
      } catch (error) {
        console.error('❌ Error al cerrar dropdown:', error);
      }
    }
  }

  // nlpr ini
  selectOption(option: string) {
    // console.log("menu:"+option);
    this.selectedIdCategoria = option; 
    if (option === 'fotografias' || option==='1') {
      this.isCulturalMenuOpen = true;
      this.isPortadasMenuOpen = false;
      //this.isCulturalMenuOpen = false;  // Asegura que el submenú de Cultural se oculte al seleccionar otra opción
      this.utilitarioService.idCategoria='1';
      localStorage.setItem('idCategoria', '1');
    }
    if (option === 'portadas' || option==='1') {
      this.isCulturalMenuOpen = false;
      this.isPortadasMenuOpen = true;
      //this.isPortadasMenuOpen = false;  // Asegura que el submenú de Cultural se oculte al seleccionar otra opción
      localStorage.setItem('idCategoria', '2');
    }
    
  }
  
  /*
  openCalendar() {
    // Aquí puedes agregar la lógica para abrir el calendario si lo deseas
    // console.log('Icono de calendario clickeado');
  }
  
  // Este método puede ser útil para manejar el evento cuando el calendario se cierra
  onCalendarClosed() {
    // console.log('Calendario cerrado');
  }*/

    selectedDateRange: { begin: Date | null, end: Date | null } = { begin: null, end: null };
    selectedDateRangeIni:null;
    selectedDateRangeFin:null;

    // Variables para el nuevo modal de fechas
    isDateRangeModalOpen = false;


  /*
  onDateChange(event: any) {
    // console.log('Fecha de cambio detectada:', event);
    this.selectedDateRange = event.value;
    // console.log('Fechas seleccionadas:', this.selectedDateRange);
  }*/

  // Métodos para el nuevo modal de fechas
  openDateRangeModal(): void {
    this.isDateRangeModalOpen = true;
  }

  closeDateRangeModal(): void {
    this.isDateRangeModalOpen = false;
  }

  onDateRangeSelectedFromModal(dateRange: { start: Date, end: Date }): void {
    // console.log('🗓️ Rango de fechas seleccionado desde modal:', dateRange);

    // Validar que las fechas sean objetos Date válidos
    if (!dateRange.start || !dateRange.end) {
      this.showWarning("Por favor seleccione un rango de fechas válido.");
      return;
    }

    const startDate = new Date(dateRange.start);
    const endDate = new Date(dateRange.end);

    // Validar que sean fechas válidas
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      this.showWarning("Las fechas seleccionadas no son válidas.");
      return;
    }

    // Validar que la fecha inicio sea menor o igual a fecha fin
    if (startDate > endDate) {
      this.showWarning("La fecha de inicio debe ser menor o igual a la fecha de fin.");
      return;
    }

    // ✅ Validar rangos de años (igual que en web)
    const yearBegin = startDate.getFullYear();
    const yearEnd = endDate.getFullYear();
    const currentYear = new Date().getFullYear();

    if (yearBegin < 1825 || yearBegin > currentYear || yearEnd < 1825 || yearEnd > currentYear) {
      this.showWarning(`Los años deben estar entre 1825 y ${currentYear}.`);
      return;
    }

    // ✅ Formatear fechas en formato yyyy-MM-dd usando función auxiliar
    const formattedStartDate = this.formatDateToIso(startDate);
    const formattedEndDate = this.formatDateToIso(endDate);

    // Validar que el formateo fue exitoso
    if (!formattedStartDate || !formattedEndDate) {
      this.showWarning("Error al formatear las fechas seleccionadas.");
      return;
    }

    this.txtFechaIni = formattedStartDate;
    this.txtFechaFin = formattedEndDate;

    // Actualizar el rango para mantener compatibilidad con código existente
    this.selectedDateRange = { begin: startDate, end: endDate };

    // console.log('✅ Fechas formateadas correctamente:', formattedStartDate, '-', formattedEndDate);

    // Ejecutar búsqueda
    this.onBuscar('');
  }

  range = new FormGroup({
      start: new FormControl(),
      end: new FormControl(),
});

  clearDates() {
      // console.log('Rango de fechas limpiar');
      // console.log('xxx'+this.selectedDateRange);
      // console.log('xxx'+this.selectedDateRange.begin);
      // console.log('xxx'+this.selectedDateRange.end);
      this.selectedDateRange = { begin: null, end: null };
      // console.log('Rango de fechas limpiado');
    }
  
  dateChanged(_type: "start" | "end", _event): void {
    // console.log("_type:"+_type+">>begin:"+this.selectedDateRange.begin+">>end:"+this.selectedDateRange.end);

    // Validar fecha inicio si se está cambiando
    if (_type === "start" && this.selectedDateRange.begin != null) {
      const startDate = new Date(this.selectedDateRange.begin);
      if (!isNaN(startDate.getTime())) {
        const year = startDate.getFullYear();
        const currentYear = new Date().getFullYear();
        if (year < 1825 || year > currentYear) {
          this.showWarning(`El año de inicio debe estar entre 1825 y ${currentYear}.`);
          this.selectedDateRange.begin = null;
          return;
        }
      }
    }

    // Solo ejecutar búsqueda cuando se selecciona la fecha FIN y ambas fechas están completas
    if (_type=="end" && this.selectedDateRange.begin!=null && this.selectedDateRange.end!=null){
      // console.log("Ambas fechas seleccionadas, ejecutando búsqueda...");

      // Validar que las fechas sean objetos Date válidos
      const beginDate = new Date(this.selectedDateRange.begin);
      const endDate = new Date(this.selectedDateRange.end);

      if (isNaN(beginDate.getTime()) || isNaN(endDate.getTime())) {
        this.showWarning("Las fechas seleccionadas no son válidas.");
        this.selectedDateRange = { begin: null, end: null };
        return;
      }

      // Validar rangos de años
      const yearBegin = beginDate.getFullYear();
      const yearEnd = endDate.getFullYear();
      const currentYear = new Date().getFullYear();

      if (yearBegin < 1825 || yearBegin > currentYear || yearEnd < 1825 || yearEnd > currentYear) {
        this.showWarning(`Los años deben estar entre 1825 y ${currentYear}.`);
        this.selectedDateRange = { begin: null, end: null };
        return;
      }

      // Validar que fecha inicio sea menor o igual a fecha fin
      if (beginDate > endDate) {
        this.showWarning("La fecha de inicio debe ser menor o igual a la fecha de fin.");
        this.selectedDateRange = { begin: null, end: null };
        return;
      }

      // ✅ Formatear fechas en formato yyyy-MM-dd usando función auxiliar
      const formattedBeginDate = this.formatDateToIso(beginDate);
      const formattedEndDate = this.formatDateToIso(endDate);

      // Validar que el formateo fue exitoso
      if (!formattedBeginDate || !formattedEndDate) {
        this.showWarning("Error al formatear las fechas seleccionadas.");
        this.selectedDateRange = { begin: null, end: null };
        return;
      }

      this.txtFechaIni=formattedBeginDate;
      this.txtFechaFin=formattedEndDate;
      // console.log("✅ Fechas seleccionadas correctamente: "+formattedBeginDate + " - "+formattedEndDate);
      this.onBuscar("");
      this.selectedDateRangeIni=null;
      this.selectedDateRangeFin=null;
      // console.log("Búsqueda completada, fechas limpiadas");
    }

    // Cuando se selecciona fecha inicio, solo mostrar en consola
    if (_type=="start"){
      // console.log("Fecha inicio seleccionada, esperando fecha fin...");
      // NO limpiar la fecha de fin para permitir la selección de rango completo
      // this.selectedDateRange.end=null; // ❌ REMOVIDO - esto causaba el problema
    }
  }

  onDateFilter(tipo, event) {
    // console.log("event:"+event);
    if (tipo==='end' && this.range.value.end!=null){
      //this.limpiar();
      this.onBuscar("");
      /*
      this.limpiar1().then(() => {
        // console.log('Limpiado correctamente');
      }).catch(error => {
        console.error('Error al limpiar:', error);
      });*/
      // console.log("blanco");
    } 
  }

  limpiar(){
    this.range.reset();
  }

  limpiar1(): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        this.range.reset();
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  onDateRangePickerOpened(opened: boolean) {
    // console.log('El selector de fechas se ha ' + (opened ? 'abierto' : 'cerrado'));
    if (opened) {
      // console.log('El selector se abrió');
    }
  }

  closeMenu() {
    this.isMenuCollapsed = true;  // Cerrar el menú principal
    this.isCulturalMenuOpen = false; // Cerrar submenú de Fotografías
    this.isPortadasMenuOpen = false; // Cerrar submenú de Portadas
  }  
  
  // nlpr fin

  goIndex(event: Event) {
    // console.log("redirigir index");
    this.utilitarioService.idCategoria="";
    this.selectedIdCategoria="";
    //delete this.utilitarioService.idCategoria.propiedad1;
    // Prevenir el comportamiento predeterminado del enlace
    event.preventDefault();
    // Ahora redirigir a '/'
    this.router.navigate(['/']);
  }

  /**
   * Método público para sincronizar la categoría y subcategoría activa desde componentes hijos
   * Se llama cuando se navega directamente por URL
   */
  setActiveHeaderCategory(idCategoria: string, idSubCategoria?: string) {
    const timestamp = new Date().toLocaleTimeString('es-PE', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });
    //console.log(`🔄 [HEADER] [${timestamp}] Sincronizando categoría activa:`, { idCategoria, idSubCategoria });

    this.selectedIdCategoria = idCategoria;
    this.utilitarioService.idCategoria = idCategoria;

    if (idSubCategoria) {
      this.selectedIdSubCategoria = idSubCategoria;
      this.utilitarioService.idSubCategoria = idSubCategoria;
    } else {
      // Si no hay subcategoría, limpiar la selección
      this.selectedIdSubCategoria = '';
      this.utilitarioService.idSubCategoria = '';
    }

    // Abrir el menú correspondiente
    if (idCategoria === '1') {
      this.isCulturalMenuOpen = true;
      this.isPortadasMenuOpen = false;
    } else if (idCategoria === '2') {
      this.isCulturalMenuOpen = false;
      this.isPortadasMenuOpen = true;
    }

    //onsole.log(`✅ [HEADER] [${timestamp}] Categoría y subcategoría sincronizadas:`, {selectedIdCategoria: this.selectedIdCategoria,selectedIdSubCategoria: this.selectedIdSubCategoria});
  }

  /**
   * Carga la geolocalización del visitante y actualiza la bandera.
   */
  loadGeoLocation(): void {
    this.geolocationService.getCountryCode().subscribe(
      (data) => {
        if (data) {
          this.countryCode = data.countryCode || 'PE';
          this.countryName = data.countryName || 'Peru';
          this.flagUrl = this.geolocationService.getFlagUrl(this.countryCode);
          this.geoLocationLoaded = true;
          // console.log('Geolocalización cargada:', this.countryName, '(' + this.countryCode + ')');
        }
      },
      (error) => {
        console.error('Error al cargar geolocalización:', error);
        // Mantener valores por defecto (Perú)
        this.countryCode = 'PE';
        this.countryName = 'Peru';
        this.flagUrl = '/assets/image/flags/pe.svg';
        this.geoLocationLoaded = true;
      }
    );
  }

  /**
   * Maneja el error cuando la imagen de la bandera no se puede cargar.
   * Usa una bandera por defecto.
   */
  onFlagError(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.src = '/assets/image/flags/default.svg';
  }

  /**
   * Carga los datos del usuario logueado y determina su nacionalidad.
   * Si tiene DNI peruano (8 dígitos), muestra bandera de Perú.
   * Si tiene documento extranjero, muestra bandera según geolocalización.
   */
  loadUserNationality(): void {
    if (!this.usuarioService.existeSesionUsuario()) {
      return;
    }

    const idUsuario = this.usuarioService.obtenerIDSessionUsuario();
    if (!idUsuario) {
      return;
    }

    // Obtener datos completos del usuario para ver su documento
    this.usuarioService.obtenerUser(idUsuario).subscribe(
      (userData) => {
        if (userData?.response?.list?.[0]) {
          const userInfo = userData.response.list[0];
          const documento = userInfo.document || '';
          const tipoDocumento = userInfo.typeDocumentId || '';

          // console.log('👤 [HEADER] Datos usuario cargados - Documento:', documento, 'Tipo:', tipoDocumento);

          // DNI peruano = exactamente 8 dígitos numéricos
          const isDNI = /^\d{8}$/.test(documento);

          if (isDNI) {
            // Usuario peruano
            this.isPeruvianUser = true;
            this.userCountryCode = 'PE';
            this.userCountryName = 'Peru';
            this.userFlagUrl = '/assets/image/flags/pe.svg';
            // console.log('🇵🇪 [HEADER] Usuario identificado como PERUANO (DNI)');
          } else {
            // Usuario extranjero - usar bandera de geolocalización
            this.isPeruvianUser = false;
            this.userCountryCode = this.countryCode;
            this.userCountryName = this.countryName;
            this.userFlagUrl = this.flagUrl;
            // console.log('🌎 [HEADER] Usuario identificado como EXTRANJERO - usando bandera:', this.userCountryCode);
          }

          // Actualizar el servicio de moneda
          this.currencyService.refreshCurrency();
        }
      },
      (error) => {
        console.error('Error al cargar datos del usuario:', error);
        // Mantener valores por defecto
        this.isPeruvianUser = true;
        this.userCountryCode = 'PE';
        this.userCountryName = 'Peru';
        this.userFlagUrl = '/assets/image/flags/pe.svg';
      }
    );
  }

  /**
   * Obtiene la URL de la bandera a mostrar.
   * SIEMPRE usa la bandera según geolocalización (prioridad sobre documento de usuario).
   */
  getCurrentFlagUrl(): string {
    // Siempre usar geolocalización, independientemente de si está logueado o no
    return this.flagUrl;
  }

  /**
   * Obtiene el nombre del país actual.
   * SIEMPRE usa el país según geolocalización (prioridad sobre documento de usuario).
   */
  getCurrentCountryName(): string {
    // Siempre usar geolocalización, independientemente de si está logueado o no
    return this.countryName;
  }

  ngOnDestroy(): void {
    // Limpiar la suscripción al servicio de comunicación del header
    if (this.headerSubscription) {
      this.headerSubscription.unsubscribe();
    }

    // Limpiar la suscripción de actualización de usuario
    if (this.usuarioActualizadoSubscription) {
      this.usuarioActualizadoSubscription.unsubscribe();
    }

    // Limpiar la suscripción del rate limit
    if (this.rateLimitSubscription) {
      this.rateLimitSubscription.unsubscribe();
    }

    // Limpiar la suscripción de login/logout
    if (this.loginStatusSubscription) {
      this.loginStatusSubscription.unsubscribe();
    }
  }

}
